var _ellipse, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4173",
    "data-name": "Group 4173",
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.793,
    height: 63.864,
    viewBox: "0 0 63.793 63.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1689",
    "data-name": "Ellipse 1689",
    cx: 30.942,
    cy: 30.942,
    rx: 30.942,
    ry: 30.942,
    transform: "translate(0.983 0.998)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4081",
    "data-name": "Group 4081",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1698",
    "data-name": "Ellipse 1698",
    cx: 25.552,
    cy: 25.552,
    rx: 25.552,
    ry: 25.552,
    transform: "translate(6.373 6.388)",
    fill: "#3a559f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4070",
    "data-name": "Group 4070",
    transform: "translate(24.295 17.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4069",
    "data-name": "Group 4069"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13900",
    "data-name": "Path 13900",
    d: "M4373.37,693.7q.027-4.611.053-9.221c.007-1.64-.035-3.281.017-4.919.026-.815-.177-1.168-1.068-1.105-1.107.078-2.225,0-3.336.027-.539.014-.8-.119-.792-.726.03-1.639.026-3.28,0-4.92-.008-.568.2-.784.768-.775,1.43.023,2.86.008,4.413.008,0-.91-.019-1.749,0-2.587a22.913,22.913,0,0,1,.191-4.022,6.922,6.922,0,0,1,6.8-5.521c1.551-.036,3.1.012,4.656-.016.592-.011.839.162.822.8-.039,1.434-.033,2.87,0,4.3.013.585-.213.77-.771.756-1.024-.027-2.05-.016-3.075,0a1.97,1.97,0,0,0-2.178,2.172c-.02,1.112.023,2.227-.016,3.338-.022.626.218.8.817.792,1.634-.032,3.269-.011,5.1-.011-.277,2.17-.539,4.229-.814,6.383h-5.086V693.7Z",
    transform: "translate(-4368.241 -659.923)",
    fill: "#17366d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4071",
    "data-name": "Group 4071",
    transform: "translate(21.766 15.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13901",
    "data-name": "Path 13901",
    d: "M4344.3,664.63q.027-4.611.053-9.221c.007-1.64-.036-3.281.017-4.919.026-.815-.177-1.168-1.068-1.105-1.107.078-2.225,0-3.337.027-.539.014-.8-.119-.792-.726.03-1.639.026-3.28,0-4.919-.008-.568.2-.784.768-.775,1.43.023,2.86.008,4.413.008,0-.91-.019-1.749,0-2.587a22.913,22.913,0,0,1,.191-4.022,6.922,6.922,0,0,1,6.8-5.521c1.551-.036,3.1.012,4.656-.016.592-.011.839.162.822.8-.039,1.434-.033,2.87,0,4.3.013.585-.213.77-.771.756-1.024-.027-2.05-.016-3.075,0a1.97,1.97,0,0,0-2.178,2.172c-.02,1.112.023,2.227-.016,3.338-.022.626.218.8.817.792,1.634-.032,3.269-.011,5.1-.011-.277,2.17-.539,4.229-.814,6.383H4350.8V664.63Z",
    transform: "translate(-4339.17 -630.852)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4076",
    "data-name": "Group 4076",
    transform: "translate(9.434 10.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4073",
    "data-name": "Group 4073",
    transform: "translate(0 4.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4072",
    "data-name": "Group 4072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13902",
    "data-name": "Path 13902",
    d: "M4198.586,642.458a1.2,1.2,0,0,1-1.2-1.2,22.494,22.494,0,0,1,7.731-16.971,1.2,1.2,0,1,1,1.573,1.807,20.1,20.1,0,0,0-6.908,15.163A1.2,1.2,0,0,1,4198.586,642.458Z",
    transform: "translate(-4197.388 -623.996)",
    fill: "#9898f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4075",
    "data-name": "Group 4075",
    transform: "translate(10.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4074",
    "data-name": "Group 4074"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13903",
    "data-name": "Path 13903",
    d: "M4322.481,579.017a1.2,1.2,0,0,1-.593-2.239,22.424,22.424,0,0,1,4.457-1.93,1.2,1.2,0,0,1,.708,2.289,20,20,0,0,0-3.979,1.724A1.2,1.2,0,0,1,4322.481,579.017Z",
    transform: "translate(-4321.283 -574.794)",
    fill: "#9898f9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4080",
    "data-name": "Group 4080",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4077",
    "data-name": "Group 4077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13904",
    "data-name": "Path 13904",
    d: "M4120.853,519.14a31.933,31.933,0,1,1,22.585-54.51,1.2,1.2,0,0,1-1.694,1.694,29.544,29.544,0,1,0,0,41.782,1.2,1.2,0,0,1,1.694,1.694A31.844,31.844,0,0,1,4120.853,519.14Z",
    transform: "translate(-4088.928 -455.275)",
    fill: "#3a559f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4078",
    "data-name": "Group 4078",
    transform: "translate(60.808 34.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13905",
    "data-name": "Path 13905",
    d: "M4789.227,854.7a1.212,1.212,0,0,1-.248-.026,1.2,1.2,0,0,1-.925-1.419c.188-.89.335-1.8.44-2.7a1.2,1.2,0,1,1,2.379.275c-.113.977-.273,1.96-.475,2.922A1.2,1.2,0,0,1,4789.227,854.7Z",
    transform: "translate(-4788.027 -849.493)",
    fill: "#3a559f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4079",
    "data-name": "Group 4079",
    transform: "translate(57.892 16.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13906",
    "data-name": "Path 13906",
    d: "M4759.209,657.74a1.2,1.2,0,0,1-1.194-1.116,29.46,29.46,0,0,0-3.368-11.817,1.2,1.2,0,0,1,2.116-1.123,31.839,31.839,0,0,1,3.642,12.777,1.2,1.2,0,0,1-1.113,1.277C4759.265,657.74,4759.237,657.74,4759.209,657.74Z",
    transform: "translate(-4754.508 -643.047)",
    fill: "#3a559f"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cddb8f2921f57b764497ef2e3ef92044.svg";
export { ForwardRef as ReactComponent };